import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'

import type { Feature } from '../feature'
import * as gql from '../gql'

/**
 * Persists scenario visibility moves from the dropdown overflow menu.
 */
export const moveToVisibilityOnRequest = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.moveToVisibility.request.observe().pipe(
      rxjs.withLatestFrom(meFeature.contexts.selectors.appContext.asObservable),
      rxjs.exhaustMap(([action, appContext]) => {
        if (!appContext) {
          return rxjs.of(
            feature.actions.moveToVisibility.cancellation
              .from(action)
              .create({
                reason: 'No app context available',
                request: action.data,
              }),
          )
        }

        const { scenarioId, visibility } = action.data

        return gql.mutations.updateScenario
          .executor({
            ...appContext,
            scenarioId,
            updates: gql.inputs.scenarioUpdates.TRANSFORMER.getGqlFrom({
              visibility,
            }),
          })
          .pipe(
            rxjs.mergeMap(response =>
              rxjs.of(
                feature.actions.moveToVisibility.success
                  .from(action)
                  .create({
                    request: action.data,
                    response,
                  }),
                feature.actions.refreshScenarios.request
                  .from('RouteBoundScenarios.MoveToVisibility.Success')
                  .create(),
              ),
            ),
            rxjs.catchError((error: Error) =>
              rxjs.of(
                feature.actions.moveToVisibility.error.from(action).create({
                  error,
                  request: action.data,
                }),
              ),
            ),
          )
      }),
    ),
)
